import { useEffect, useRef } from "react";

const VIGNETTE_ZONE_ID = "11007459";
const VIGNETTE_SCRIPT_URL = "https://n6wxm.com/vignette.min.js";

export default function MonetagVignette({ className = "", style = {} }) {
  const containerRef = useRef(null);
  const scriptAdded = useRef(false);

  useEffect(() => {
    if (scriptAdded.current) return;
    scriptAdded.current = true;

    const container = containerRef.current;
    if (!container) return;

    // Load the vignette script
    const script = document.createElement("script");
    script.dataset.zone = VIGNETTE_ZONE_ID;
    script.src = VIGNETTE_SCRIPT_URL;
    script.async = true;
    document.body.appendChild(script);

    // Watch for the injected element
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            if (
              node.dataset?.zone === VIGNETTE_ZONE_ID ||
              node.id?.includes(VIGNETTE_ZONE_ID) ||
              node.querySelector?.(`[data-zone="${VIGNETTE_ZONE_ID}"]`)
            ) {
              container.appendChild(node);
              observer.disconnect();
              return;
            }
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Fallback polling
    const interval = setInterval(() => {
      const el = document.querySelector(`[data-zone="${VIGNETTE_ZONE_ID}"]`);
      if (el && el.parentNode !== container) {
        container.appendChild(el);
        clearInterval(interval);
        observer.disconnect();
      }
    }, 500);

    return () => {
      observer.disconnect();
      clearInterval(interval);
      if (script.parentNode) script.parentNode.removeChild(script);
      scriptAdded.current = false;
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={className}
      style={{
        minWidth: "160px",
        minHeight: "600px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...style,
      }}
    />
  );
}